import React, { Component } from 'react';
import { connect } from 'react-redux';

import { CloudinaryContext, Image } from 'cloudinary-react';
import SwitchSelector from "react-switch-selector";

const configurationManager = require('../../../../utils/config/configurationManager');
const stateManager = require('../../../../utils/state/stateManager.js');
const basketUtil = require('../../../../utils/basket/basketUtil.js');
const stringUtil = require('../../../../utils/string/stringUtil');
const storeUtil = require('../../../../utils/store/storeUtil');
const constants = require('../../../../utils/domain/constants');

class Header extends Component 
{
    render()
    {
        var state = stateManager.getStore().getState();
        const logoUrl = state.storefront.logoImageUrl ? state.storefront.logoImageUrl : state.property.logoImageUrl;

        return (
                    <div style={{marginBottom:'10px'}}>
                        <CloudinaryContext cloudName={configurationManager.getAppConfig().cdnAppCloudName}>
                            <Image publicId={logoUrl} style={{width:'100%'}}/>
                        </CloudinaryContext>
                        <div style={{marginLeft:'10px', marginRight:'10px'}}>
                            <h4 style={{fontWeight:'bold', marginTop:'5px', marginBottom:'0px'}}>{state.property.name}</h4>
                            <div className='smallText'>{state.property.address}</div>
                            
                        </div>
                        <hr style={{marginTop:'5px', marginBottom:'0px'}}/>    

                        {
                            stringUtil.areStringSame(stateManager.getStore().getState().currentMode, constants.applicationMode.overPhonePayment)
                                ? null 
                                : this.getDispatchTypeOptionsWidget()
                        }
                    </div>
        );
    }

    getDispatchTypeOptionsWidget()
    {
        var state = stateManager.getStore().getState();
        if (state.currentMenu == null)
            return null;

        const availableDispatchTypes = state.allowedDispatchTypes.filter(dispatchTypeConfiguration => !storeUtil.isStoreClosedForDispatchType(dispatchTypeConfiguration.dispatchType));

        if(availableDispatchTypes.length === 0)
            return null;

        var options = [];

        availableDispatchTypes.forEach(dispatchTypeConfiguration =>
        {
            let option = {};
            option.label = dispatchTypeConfiguration.dispatchType;
            option.value = dispatchTypeConfiguration.dispatchType;
            options.push(option);
        });
        var index = availableDispatchTypes.findIndex(aD => stringUtil.areStringSame(aD.dispatchType, state.basket.order.dispatchType));
        
        return <div style={{marginLeft:'10px', marginRight:'10px', marginTop:'10px', height: 40}}>
                    <SwitchSelector
                    onChange={this.onDispatchTypeChange}
                    options={options}
                    initialSelectedIndex={index}
                    backgroundColor={`var(--switch_selector-background-color)`}
                    selectedBackgroundColor={`var(--switch_selector-selected-background-color)`}
                    fontColor={`var(--switch_selector-font-color)`}
                    selectedFontColor={`var(--switch_selector-selected-font-color)`}
                    optionBorderRadius={10}
                    wrapperBorderRadius={10}
                    border={200}/>
                </div>
    }

    onDispatchTypeChange(selectedDispatchOption)
    {
        basketUtil.resetBasket(selectedDispatchOption)
    }
}

const mapStateToProps = state => 
{
    return { 
        basketVersion: state.basketVersion,
    }
}

export default connect(mapStateToProps)(Header)